@if (shown().length > 0) {
  @for (item of shown(); track $index) {
    @switch (item.part.kind) {
      @case ('refs') {
        @for (segment of item.refSegments; track $index) {
          @if (segment.kind === 'ref' && segment.ref.uid === null) {
            <!-- An unnamed entity has no uid to put in a chip, so it reads as the sentence does. -->
            <span data-part="ref-unnamed">{{
              'features.plan.warnings.unnamed_entity'
                | translate
                  : {
                      type:
                        typeLabels().get(segment.ref.entityType.toUpperCase()) ??
                        segment.ref.entityType
                    }
            }}</span>
          } @else if (segment.kind === 'ref') {
            <!-- inline-flex stops a line-through around it from reaching its text. -->
            <span
              data-part="ref"
              class="bg-interactive inline-flex items-baseline gap-[3px] rounded-[2px] px-1 whitespace-nowrap"
              [class]="muted() ? 'line-through' : 'text-text-primary'"
              ><span class="text-[10px]" [class.text-text-tertiary]="!muted()">{{
                typeLabels().get(segment.ref.entityType.toUpperCase()) ??
                  segment.ref.entityType
              }}</span
              ><span class="font-mono text-[11px] [font-variant-ligatures:none]">{{
                segment.ref.uid
              }}</span></span
            >
          } @else {
            <span>{{ segment.text }}</span>
          }
        }
      }
      @case ('duration') {
        <span
          data-part="duration"
          class="font-mono text-[11.5px] font-semibold whitespace-nowrap tabular-nums"
          [class.text-warning-ink]="!muted()"
          >{{ item.text }}</span
        >
      }
      @case ('datetime') {
        <span
          data-part="datetime"
          class="font-mono text-[11px] whitespace-nowrap tabular-nums"
          [class.text-text-primary]="!muted()"
          >{{ item.text }}</span
        >
      }
      @case ('value') {
        <span
          data-part="value"
          class="font-mono text-[11px] whitespace-nowrap tabular-nums"
          [class.text-text-primary]="!muted()"
          >{{ item.text }}</span
        >
      }
      @default {
        <span>{{ item.text }}</span>
      }
    }
  }
} @else {
  <span>{{ body() }}</span>
}
